module.exports = __webpack_public_path__ + "media/images/contents/questionnaires/template_pattern_3-fcfad6b8ef7c3001667384128217459a.png";